module.exports = __webpack_public_path__ + "static/img/5.d8f3912.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/13/sp/5.png
// module id = avGD
// module chunks = 0